import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

import {SuiModalService} from '@angular-ex/semantic-ui';
import {switchMap} from 'rxjs/operators';

import {TOPIC_KINDS} from '../../../../../../core/constants';
import {Topic} from 'src/app/core/models/topics/topics.model';
import {TopicsService} from '../../../../../../core/services/topics/topics.service';
import {ToastService} from '../../../../../../core/services/toast/toast.service';

@Component({
  selector: 'app-topic-form',
  templateUrl: './topic-form.component.html',
  styleUrls: ['./topic-form.component.css'],
  standalone: false,
})
export class TopicFormComponent implements OnInit {
  protected readonly TOPIC_KINDS = TOPIC_KINDS;

  public topic: Topic = {
    _id: '',
    name: '',
    englishName: '',
    description: '',
    englishDescription: '',
    kind: '',
    isInvisible: false,
    isSubjectArea: false,
  };

  topicForm!: UntypedFormGroup;

  constructor(
    fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private topicsService: TopicsService,
    public modalService: SuiModalService,
    private router: Router,
    private toastService: ToastService,
  ) {
    this.topicForm = fb.group({
      name: ['', Validators.required],
      englishName: ['', Validators.required],
      description: [''],
      englishDescription: [''],
      isSubjectArea: [false],
      isInvisible: [false],
      kind: [''],
    })
  }

  ngOnInit() {
    if (this.route.snapshot.data.isSubjectArea) {
      this.topic.isSubjectArea = true;
    }

    this.route.params.pipe(
      switchMap(({id}) => this.topicsService.getOne(id)),
    ).subscribe(topic => {
      this.topic = topic;
      this.topicForm.patchValue(this.topic);
    });
  }

  public submit(): void {
    if (this.topic._id) {
      // update topic
      this.topicsService.updateOne(this.topicForm.value, this.topic._id).subscribe((res) => {
        this.infoModalAndReroute(res, true);
      });
    } else {
      // add new topic
      this.topicsService.createOne(this.topicForm.value).subscribe((res) => {
        this.infoModalAndReroute(res, false);
      });
    }
  }

  private infoModalAndReroute(res: Topic, edit: boolean): void {
    const type = res.isSubjectArea ? 'Fachrichtung' : 'Kategorie';
    const verb = edit ? 'bearbeitet' : 'erstellt';
    this.toastService.success(`${type} ${verb}`, `Die ${type} wurde erfolgreich ${verb}.`);
    this.router.navigate([edit ? '../..' : '..'], {relativeTo: this.route});
  }
}
